export default "__VITE_ASSET__CYDJCcKZ__"